import { render } from "./FollowPage.vue?vue&type=template&id=d3022d1e&scoped=true&ts=true"
import script from "./FollowPage.vue?vue&type=script&lang=ts"
export * from "./FollowPage.vue?vue&type=script&lang=ts"

import "./FollowPage.vue?vue&type=style&index=0&id=d3022d1e&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3022d1e"]])

export default __exports__